var buttonAnalytics = {
  value: 'Button',
  actions: {
    onClick: {
      type: 'BUTTON_CLICK',
      payload: 'Click'
    }
  }
};

export default buttonAnalytics;
